import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { firebase } from "astrid-firebase";
import { updateDocument } from "astrid-firestore/src/helpers";

import { useProfile } from "../../../authentication/state/profile";
import Table from "../../../tables/components/Table";

import HomeLayout from "../../layouts/HomeLayout/HomeLayout";

import useStarred from "./hooks/useStarred";
import useStarredColumns from "./hooks/useStarredColumns";

export default function FavoriteProductionsWidget({ language }) {
	const { t } = useTranslation();

	const user = useProfile();

	const navigate = useNavigate();

	const [starred, loading, error] = useStarred();

	const filteredStarred = starred
		? starred.filter((production) => !language || production.language === language)
		: [];

	const columns = useStarredColumns();

	const getDropdownMenuOptions = (production) => [
		{
			text: t("toProduction", "To production"),
			linkTo: `/production/${production.id}`,
		},
		{
			text: t("removeReminder", "Remove reminder"),
			action() {
				return updateDocument(user.ref, {
					starredProductions: firebase.firestore.FieldValue.arrayRemove(production.id),
				});
			},
		},
	];

	return (
		<HomeLayout.Widget icon="star" color="yellow" header={t("favoriteProds", "Favourite productions")}>
			<Table
				data={filteredStarred}
				error={error}
				loading={loading}
				columns={columns}
				onClick={({ id }) => navigate(`/production/${id}`)}
				getDropdownMenuOptions={getDropdownMenuOptions}
				noDataAvailableMessage={t("noFavouriteProductions", "You have no favourite productions")}
			/>
		</HomeLayout.Widget>
	);
}
